import { render, staticRenderFns } from "./VProjectMemberForm.vue?vue&type=template&id=e44db0f6&"
import script from "./VProjectMemberForm.vue?vue&type=script&lang=js&"
export * from "./VProjectMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports